// removed by extract-text-webpack-plugin
module.exports = {"bylinewrapper":"dh-stille-spesial-bylinewrapper","nowrap":"dh-stille-spesial-nowrap","bylinetext":"dh-stille-spesial-bylinetext"};


//////////////////
// WEBPACK FOOTER
// ./src/v1/components/Footer/Byline/index.css
// module id = 74
// module chunks = 0